import { ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';

import { useCalculationsStore } from '@/store/calculations';
import { useClientsStore } from '@/store/clients';

import { useCurrentCalculatorSegments } from '@/composables/useCurrentCalculatorSegments';
import { useCurrentCalculator } from '@/composables/useCurrentCalculator';
import { useNavigationHelpers } from '@/composables/useNavigationHelpers';

export function useAddCalculation() {
  const name = ref('');
  const calculationStore = useCalculationsStore();
  const clientsStore = useClientsStore();

  const router = useRouter();
  const route = useRoute();

  const { requiredSegments, validRequiredSegments } = useCurrentCalculatorSegments();
  const { currentCalculator } = useCurrentCalculator();
  const { getInitialCalculationNavigation } = useNavigationHelpers();

  function handleAddCalculation() {
    const clientUuid = route.params.clientId;

    if (typeof clientUuid !== 'string') {
      throw Error('zły uuid klienta');
    }

    const client = clientsStore.getClientByUuid(clientUuid);

    if (!client) {
      throw Error('Nie znaleziono klienta');
    }

    const newCalculation = calculationStore.addNewCalculation(
      client,
      name.value,
      Number(currentCalculator.value?.id)
    );

    const baseParams = {
      ...route.params,
      calculationId: newCalculation.uuid,
    };

    if (!requiredSegments.value?.length) {
      router.push({
        name: 'SelectSegmentView',
        params: baseParams,
      });
      return;
    }

    const lastCalculation = calculationStore.getLastClientCalculation(
      newCalculation.uuid,
      client.uuid,
      Number(currentCalculator.value?.id)
    );

    requiredSegments.value.forEach((segment) => {
      const lastCalculationSegment = lastCalculation?.calculation_segments.find(
        (calculationSegment) => calculationSegment.segment_id === segment.id
      );

      if (lastCalculationSegment) {
        calculationStore.copySegmentToCalculation(
          newCalculation.uuid,
          lastCalculationSegment,
          segment
        );
      } else {
        calculationStore.addSegmentToCalculation(newCalculation.uuid, segment);
      }
    });

    if (!validRequiredSegments.value?.length) {
      console.warn('No segments have navigable views, falling back to segment selection');
      router.push({
        name: 'SelectSegmentView',
        params: baseParams,
      });
      return;
    }

    const navigation = getInitialCalculationNavigation(validRequiredSegments.value, baseParams);

    if (navigation?.route) {
      router.push(navigation.route);
    } else {
      router.push({
        name: 'SelectSegmentView',
        params: baseParams,
      });
    }
  }

  return {
    name,
    handleAddCalculation,
  };
}
